module.exports = __webpack_public_path__ + "img/legacy-shape-18.17561f03.png";